export var ReplayState;!function(A){A.NOT_AVAILABLE="NOT_AVAILABLE",A.IDLE="IDLE",A.LOADING="LOADING",A.PLAYING="PLAYING"}(ReplayState||(ReplayState={}));